import { ActionButtonProps, Box, BoxProps, Form, Icon, Spacer } from '@jfs/ui-new'
import { Button } from '../../components/AdminButton'
import { useEffect, useRef, useState } from 'react'
import { CloseForm } from '../../components/CloseForm'
import { ModalAlertView } from '../../components/ModalAlertView'
import { useLazyApiData, useStores } from '../../data/store'
import { CardSchema, CardTypes, getSchemaData, InstrumentTypes, TransactionType } from '../../utils/constants'
import { formData } from './formData'

const RoutingRulesForm = (props: any) => {
  const { initialData = {}, id = null, isEditable = false, isDeletable = false, onUpdate, onClose } = props

  const {
    addRuleAction,
    deleteRuleAction,
    updateRuleAction,
    entityIdMap,
    payerbankIds,
    fetchPayerBankIds,
    message,
    routingRules,
  } = useStores((store) => ({
    addRuleAction: store.routingRule.addRule,
    deleteRuleAction: store.routingRule.deleteRule,
    updateRuleAction: store.routingRule.updateRule,
    fetchPayerBankIds: store.routingRule.fetchPayerBankIds,
    payerbankIds: store.routingRule.getPayerBankIds(),
    lengthPbank: store.routingRule.payerBankIds.length,
    entityIdMap: store.entityMaster.getEntityMap(),
    message: store.message.getFormMessage(),
    routingRules: store.routingRule.getRoutingList(),
  }))

  const [processor, setProcessor] = useState(initialData.processor ?? '')
  const [toggle, setToggle] = useState(false)

  const formValues = useRef<any>({})

  const [lazyAdd, lazyAddHandler] = useLazyApiData(addRuleAction)
  const [lazyUpdate, lazyUpdateHandler] = useLazyApiData(updateRuleAction)
  const [lazyDelete, lazyDeleteHandler] = useLazyApiData(deleteRuleAction)

  useEffect(() => {
    fetchPayerBankIds()
  }, [fetchPayerBankIds])

  useEffect(() => {
    if (lazyAddHandler.state === 'fulfilled') {
      onUpdate()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [lazyAddHandler])

  useEffect(() => {
    if (lazyUpdateHandler.state === 'fulfilled') {
      onUpdate()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [lazyUpdateHandler])

  useEffect(() => {
    if (lazyDeleteHandler.state === 'fulfilled') {
      onUpdate()
      setToggle(false)
    }
    if (lazyDeleteHandler.state === 'rejected') {
      setToggle(false)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [lazyDeleteHandler])

  const onToggle = () => {
    setToggle(true)
  }

  const updateRule = (data: any) => {
    lazyUpdate({ ...data, processor })
  }

  const addRule = (data: any) => {
    lazyAdd({ ...data, processor })
  }

  const onDismiss = () => {
    setToggle(false)
  }

  const onDelete = () => {
    lazyDelete({
      id,
      ...formValues.current,
      processor,
    })
  }

  const getLoading = () => {
    return lazyUpdateHandler.state === 'pending' || lazyAddHandler.state === 'pending'
  }

  const setEntityProcessor = (values: any) => {
    try {
      const entityIdName = values.transactionInitiatingEntityId
      const nameArr = entityIdName?.split('-')
      const name = nameArr?.length === 2 ? nameArr[1] : ''
      setProcessor(name)
    } catch (e) {
      console.log({ e })
    }
  }

  const handleActions = ({ values, title, defaultActionButtonOnSubmit }: ActionButtonProps) => {
    formValues.current = values
    setEntityProcessor(values)
    const handleOnPress = () => {
      defaultActionButtonOnSubmit()
    }

    return (
      <Box paddingBottom={16} flexDirection="row">
        <ModalAlertView
          onPress={onDelete}
          show={toggle}
          onDismiss={onDismiss}
          title="Delete Package To MId"
          buttonTitle="Delete"
          message={`Is this final. This will delete mapping with ID ${id}.`}
          isLoading={lazyDeleteHandler.state === 'pending'}
        />
        {isEditable && <Button title={id ? 'Update Rule' : title} onPress={handleOnPress} isLoading={getLoading()} />}
        <Spacer direction="horizontal" size={16} />
        {isDeletable && id && (
          <Box
            onPress={onToggle}
            bg="RED"
            underlayColor="ERROR"
            p={'MEDIUM'}
            justify={'center'}
            align={'center'}
            borderRadius={4}>
            <Icon id="DELETE" size={24} color="WHITE" />
          </Box>
        )}
      </Box>
    )
  }

  return (
    <Box onPress={() => {}} {...styles.formContainer}>
      <CloseForm onClose={onClose} />
      <Form
        initialValues={initialData}
        formData={formData({
          id,
          addRule,
          updateRule,
          payerbankIds,
          cardType: getSchemaData(CardTypes),
          schema: getSchemaData(CardSchema),
          entityID: entityIdMap,
          txnType: getSchemaData(TransactionType),
          instrumentType: getSchemaData(InstrumentTypes),
          processor: processor,
          message,
          isAssigned: routingRules[id]?.isAssigned ?? 'N',
        })}
        actionButtons={handleActions}
      />
    </Box>
  )
}

export { RoutingRulesForm }

const styles = {
  formContainer: {
    underlayColor: 'WHITE',
    height: '100vh',
    overflow: 'auto',
    bg: 'WHITE',
    padding: 'MEDIUM',
  } as BoxProps,
}
